import { useEffect } from 'react';

const useDraftSync = () => {
  useEffect(() => {
    // Listen for storage changes to sync drafts between tabs/windows
    const handleStorageChange = (e) => {
      if (e.key && e.key.startsWith('cometchat_draft_')) {
        // Dispatch custom event to notify other components about draft changes
        window.dispatchEvent(new CustomEvent('draftChanged', {
          detail: {
            key: e.key,
            newValue: e.newValue,
            oldValue: e.oldValue
          }
        }));
      }
    };

    // Listen for storage events (works across tabs/windows)
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};

export default useDraftSync;